import { render, staticRenderFns } from "./CharacterBuilderClassManeuvers.vue?vue&type=template&id=04fce8f6&lang=pug&"
import script from "./CharacterBuilderClassManeuvers.vue?vue&type=script&lang=ts&"
export * from "./CharacterBuilderClassManeuvers.vue?vue&type=script&lang=ts&"
import style0 from "./CharacterBuilderClassManeuvers.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports